var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.3,
    height: 23.151,
    viewBox: "0 0 19.3 23.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.3,22.785V20.19c0-2.866-1.936-5.19-4.325-5.19H8.325C5.936,15,4,17.324,4,20.19v2.595",
    transform: "translate(-4 -1.634)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.092,
    cy: 5.092,
    r: 5.092,
    transform: "translate(3.558)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDark);
export default __webpack_public_path__ + "static/media/user-dark.7962b72ac2c9bebcc219b6ce6d883190.svg";
export { ForwardRef as ReactComponent };